import { createTheme } from "@mui/material/styles";

/**
 * Material-UI Theme Configuration for Bubakii
 * Matches the brand colors from bubakiiTheme.js
 */
export const muiTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#005249",
      light: "#23897A",
      dark: "#003D35",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F3B431",
      light: "#F5C85A",
      dark: "#D9A01F",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#5CB85C",
      light: "#7EC87E",
      dark: "#4A9A4A",
    },
    warning: {
      main: "#F3B431",
      light: "#F5C85A",
      dark: "#D9A01F",
    },
    error: {
      main: "#D9534F",
      light: "#E17572",
      dark: "#C43E3A",
    },
    info: {
      main: "#5BC0DE",
      light: "#7CCEE5",
      dark: "#4BA5C0",
    },
    background: {
      default: "#F9F9F9",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#2F2F2F",
      secondary: "#666666",
    },
    action: {
      selected: "#E6F3F1",
      hover: "#F5F5F5",
      disabled: "rgba(0, 0, 0, 0.26)",
      disabledBackground: "rgba(0, 0, 0, 0.12)",
    },
    divider: "rgba(0, 0, 0, 0.12)",
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
          textTransform: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        },
      },
    },
    // 16px floor prevents iOS Safari zoom-on-focus
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
        input: {
          fontSize: 16,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          fontSize: 16,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
      },
    },
  },
});

